import { AppContext } from "next/app";

export function isServerSide(appContext: AppContext): boolean {
  return !!(typeof window === "undefined" && appContext?.ctx?.res?.writeHead);
}
